import { render, staticRenderFns } from "./RecentReleasesWidget.vue?vue&type=template&id=f6d7cecc&scoped=true"
import script from "./RecentReleasesWidget.vue?vue&type=script&lang=js"
export * from "./RecentReleasesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d7cecc",
  null
  
)

export default component.exports